module.exports = __webpack_public_path__ + "static/img/tip.b4375f65.gif";